import React from 'react';
import { compose } from 'recompose';
import styled, { StylesProps } from '../../../../../lib/styles';

import explainerBlockStyles from './ExplainerBlock_styles';
import Typography from '../../../../../components/presentational/Typography';
import ExplainerProduct, { ExplainerProductProps } from './ExplainerProduct';
import { Color } from '../../../../../lib/theme';

export interface ExplainerBlockData {
  type: 'explainer_block';
  title?: string;
  subtitle?: string;
  disclaimer?: string;
  backgroundColor?: Color;
  products: ExplainerProductProps[];
  shrink?: boolean;
}

export interface ExplainerBlockProps {
  block: ExplainerBlockData;
}

const ExplainerBlock = ({
  block: { title, subtitle, products, disclaimer, shrink },
  styles,
}: ExplainerBlockProps & StylesProps<typeof explainerBlockStyles>) => {
  return (
    <div className={styles.panel}>
      <div className={styles.container}>
        {(title || subtitle) && (
          <div className={styles.headings}>
            {title && (
              <Typography>
                <h1>{title}</h1>
              </Typography>
            )}
            {subtitle && (
              <Typography weight={'normal'}>
                <h3 dangerouslySetInnerHTML={{ __html: subtitle }} />
              </Typography>
            )}
          </div>
        )}

        <div className={styles.products}>
          {products.map((props, i) => (
            <ExplainerProduct key={i} {...props} shrink={shrink} />
          ))}
        </div>

        {disclaimer && (
          <Typography
            color={'dark_grey'}
            align={'center'}
            dangerouslySetInnerHTML={{ __html: disclaimer }}
          />
        )}
      </div>
    </div>
  );
};

export default compose(styled(explainerBlockStyles))(ExplainerBlock);
